export default "__VITE_ASSET__BdfIu8Fm__"